import { useState } from 'react';
import { useNativeEvent } from './useNativeEvent';
import { useInstanceId } from './useInstanceId';

/**
 * 현재 화면이 포그라운드에 있는지 판별하는 훅
 * - useNativeEvent의 viewDidAppear/viewDidDisappear로 포그라운드 상태 추적
 */
export const useIsForegroundNow = () => {
  const instanceId = useInstanceId();
  const [isForeground, setIsForeground] = useState(true);

  useNativeEvent('viewDidAppear', instanceId, () => {
    setIsForeground(true);
  });
  useNativeEvent('viewDidDisappear', instanceId, () => {
    setIsForeground(false);
  });

  return isForeground;
};
